export default {
  SCHOOLER_HOMEPAGE_URL: 'https://pages.responder.co.il/schooler',
};
